// ============================================================
//  PLAYMAKERS GROUP — SITE DATA
//  Edit all website content from this single file.
// ============================================================

export const COMPANY = {
  name: "Playmakers Group",
  shortName: "PMG",
  tagline: "Wealth Built on Precision.",
  subTagline:
    "A full-service financial LLC offering investment advisory, asset management, and access to global markets — built for individuals and institutions who demand excellence.",
  domain: "pmg.today",
  email: "info@pmg.today",
  
  address: "Africa",
  founded: "2024",
  registration: "Registered LLC",
};

export const STATS = [
  { value: "$1M+",  label: "Assets Under Advisory" },
  { value: "100+",    label: "Active Clients" },
  { value: "12+",    label: "Global Markets" },
  { value: "98%",    label: "Client Retention" },
];

export const SERVICES = [
  {
    id: "investment-advisory",
    title: "Investment Advisory",
    short: "Expert guidance tailored to your financial goals and risk appetite.",
    features: ["Portfolio risk assessment", "Personalised strategy", "Quarterly performance reviews", "Market outlook reports"],
  },
  {
    id: "asset-management",
    title: "Asset Management",
    short: "Professional management of your portfolio across multiple asset classes.",
    features: ["Active portfolio management", "Multi-asset diversification", "Risk-adjusted returns", "Transparent reporting"],
  },
  {
    id: "crypto",
    title: "Crypto & Digital Assets",
    short: "Regulated exposure to the digital asset economy.",
    features: ["Bitcoin & Ethereum positions", "Altcoin research", "Crypto portfolio structuring", "Risk management"],
  },
  {
    id: "stocks",
    title: "Stocks & Equities",
    short: "Access to local and global equity markets.",
    features: ["NGX & international stocks", "Fundamental research", "Growth & dividend strategies", "Real-time execution"],
  },
  {
    id: "venture-capital",
    title: "Venture Capital",
    short: "Strategic capital deployment into high-growth ventures and emerging businesses across Africa and beyond.",
    features: ["Series A & seed funding", "Portfolio company support", "Deal flow & due diligence", "Exit strategy planning"],
  },
  {
    id: "academy",
    title: "PMG Academy",
    short: "World-class tech education to build the next generation of African innovators.",
    features: ["Cryptocurrency trading", "LLM & AI training", "Web3 & blockchain", "Software development"],
    hasEnrollment: true,
  },
];

export const TEAM = [
  {
    id: 1,
    name: "Michael Hyacinth",
    role: "Founder & CEO",
    bio: "Visionary entrepreneur and the driving force behind Playmakers Group. Michael founded PMG with a mission to democratise access to professional-grade financial services across Africa.",
    initials: "MH",
  },
  {
    id: 2,
    name: "Philip Chilo",
    role: "COO & Head of Brand",
    bio: "Multidisciplinary professional with 5+ years of experience across industries from fashion and music to tech and education. Leads brand engineering and develops growth strategies for Playmakers Group.",
    initials: "PC",
  },
  {
    id: 3,
    name: "Igwe Eziokwu",
    role: "Lead Engineer & Frontend Developer",
    bio: "Full-stack software engineer specialising in frontend architecture, React, and Flutter development. Architects and maintains the technical infrastructure powering the PMG digital ecosystem.",
    initials: "IE",
  },
];

export const WHY_US = [
  {
    title: "Client-First Philosophy",
    body: "Every decision we make is measured by one question: is this in the client's best interest? No conflicts of interest. No hidden incentives.",
  },
  {
    title: "Institutional-Grade Execution",
    body: "We access the same markets, research, and infrastructure as major banks — so our clients benefit from professional-grade pricing and speed.",
  },
  {
    title: "Full Transparency",
    body: "Detailed reporting, clear fee structures, and real-time portfolio visibility. You always know exactly where your money is and how it is performing.",
  },
  {
    title: "Regulated & Trustworthy",
    body: "Fully registered and compliant with applicable financial regulations. Your capital is always protected by a robust legal framework.",
  },
];

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "About",    href: "#about" },
  { label: "Team",     href: "#team" },
  { label: "Contact",  href: "#contact" },
];

export const SOCIAL = {
  tiktok: "https://www.tiktok.com/@pmg.ventures?_r=1&_t=ZS-95nWzQC6Fsq",
  x:      "https://x.com/pmgventures?s=21",
  telegram: "https://t.me/+nElKNiC_2ac2M2Zk",
};

export const CALENDLY_URL = "https://calendly.com/pmg-info/30min";

export const EMAILJS = {
  academyTemplateId: "template_4hjaq8k",
  serviceId: "service_ilwfe7a",
  templateId: "template_z8p9rag",
  publicKey:  "NK0EPLRprO5qTjIUs",
};
